import { useContext } from 'react';
import { SiteChromeDynamicContext } from "./SiteChromeDynamicContext";
export var useSiteChromeDynamicContext = function useSiteChromeDynamicContext() {
  var context = useContext(SiteChromeDynamicContext);
  if (context === undefined) {
    throw new Error('useSiteChromeDynamicContext must be used within a SiteChromeDynamicContextProvider');
  }
  return context;
};